import { Outlet } from 'react-router-dom';
import TopBar from './TopBar.jsx';
import AuthModals from './AuthModals.jsx';
import PremiereBanner from './PremiereBanner.jsx';
import WatchlistBanner from './WatchlistBanner.jsx';
import { useAuthStore } from '../lib/stores.js';
import usePremiereStream from '../hooks/usePremiereStream.js';
import useWatchlistStream from '../hooks/useWatchlistStream.js';
import styles from './AppShell.module.css';

export default function AppShell() {
  const token = useAuthStore((s) => s.token);
  // Only run the SSE streams when authenticated.
  usePremiereStream(token);
  useWatchlistStream(token);

  return (
    <div className={styles.shell}>
      <TopBar />
      <main className={styles.main}>
        <Outlet />
      </main>
      <AuthModals />
      <PremiereBanner />
      <WatchlistBanner />
    </div>
  );
}
